import { api } from "./api";
import * as endpoints from "../data/links/endpoints";

export async function getAllUsers({ signal }) {
  return api
    .get(endpoints.GET_ALL_USERS, { signal })
    .then((res) => res.data.users)
    .catch((error) => error.response);
}

export async function getDeviceStatistics({ signal }) {
  return api
    .get(endpoints.GET_DEVICE_STATISTICS, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function blockUser({ userId }) {
  let raw = {
    user_id: userId,
  };
  return api.post(endpoints.BLOCK_USER, raw).then((res) => res);
}
